/* tslint:disable */
/* eslint-disable */
/**
 * True one Services API
 * True one service for form Builder
 *
 * The version of the OpenAPI document: 4.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ShiftPattern } from './ShiftPattern';
import {
    ShiftPatternFromJSON,
    ShiftPatternFromJSONTyped,
    ShiftPatternToJSON,
} from './ShiftPattern';

/**
 * 
 * @export
 * @interface CreateScheduleRequest
 */
export interface CreateScheduleRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateScheduleRequest
     */
    templateId?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateScheduleRequest
     */
    machineId?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateScheduleRequest
     */
    frequency?: CreateScheduleRequestFrequencyEnum;
    /**
     * 
     * @type {string}
     * @memberof CreateScheduleRequest
     */
    cronExpression?: string;
    /**
     * 
     * @type {ShiftPattern}
     * @memberof CreateScheduleRequest
     */
    shiftPattern?: ShiftPattern;
    /**
     * 
     * @type {string}
     * @memberof CreateScheduleRequest
     */
    startDate?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateScheduleRequest
     */
    endDate?: string;
}


/**
 * @export
 */
export const CreateScheduleRequestFrequencyEnum = {
    Daily: 'DAILY',
    Weekly: 'WEEKLY',
    PerShift: 'PER_SHIFT',
    Custom: 'CUSTOM'
} as const;
export type CreateScheduleRequestFrequencyEnum = typeof CreateScheduleRequestFrequencyEnum[keyof typeof CreateScheduleRequestFrequencyEnum];


/**
 * Check if a given object implements the CreateScheduleRequest interface.
 */
export function instanceOfCreateScheduleRequest(value: object): value is CreateScheduleRequest {
    return true;
}

export function CreateScheduleRequestFromJSON(json: any): CreateScheduleRequest {
    return CreateScheduleRequestFromJSONTyped(json, false);
}

export function CreateScheduleRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateScheduleRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'templateId': json['templateId'] == null ? undefined : json['templateId'],
        'machineId': json['machineId'] == null ? undefined : json['machineId'],
        'frequency': json['frequency'] == null ? undefined : json['frequency'],
        'cronExpression': json['cronExpression'] == null ? undefined : json['cronExpression'],
        'shiftPattern': json['shiftPattern'] == null ? undefined : ShiftPatternFromJSON(json['shiftPattern']),
        'startDate': json['startDate'] == null ? undefined : json['startDate'],
        'endDate': json['endDate'] == null ? undefined : json['endDate'],
    };
}

export function CreateScheduleRequestToJSON(value?: CreateScheduleRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'templateId': value['templateId'],
        'machineId': value['machineId'],
        'frequency': value['frequency'],
        'cronExpression': value['cronExpression'],
        'shiftPattern': ShiftPatternToJSON(value['shiftPattern']),
        'startDate': value['startDate'],
        'endDate': value['endDate'],
    };
}

